import React from 'react';
import * as S from './processing-payment.organism.style';
import { Text } from '../../atoms/text/text.atom';
import { useTranslation } from 'react-i18next';

export const ProcessingPaymentCard: React.FC = () => {
  const { t } = useTranslation();
  return (
    <S.Card padding="2.5rem">
      <S.Container textAlign="center">
        <S.LoadingSpinner />
        <S.Title size="1.75rem" weight="700" color="#1f2937">
          VENDEPAY
        </S.Title>
        <S.Title
          size="1.5rem"
          weight="600"
          color="#10b981"
          style={{ marginTop: '1rem' }}
        >
          {t('completeYourPurchase')}
        </S.Title>
      </S.Container>

      <S.Container margin="2rem 0" textAlign="center">
        <S.Title size="1.25rem" weight="600" color="#1f2937">
          {t('justABitMore')}
        </S.Title>
        <Text size="1.125rem" color="#4b5563" align="center">
          {t('processingYourPayment')}
          <br />
          {t('accessWillBeGranted')}
        </Text>
      </S.Container>

      <S.ProgressBarContainer>
        <S.ProgressBar />
      </S.ProgressBarContainer>

      <S.Container textAlign="center">
        <Text size="1rem" weight="600" color="#10b981">
          {t('processingPayment')}
        </Text>
        <Text size="0.875rem" color="#6b7280" style={{ marginTop: '1rem' }}>
          {t('doNotClosePage')}
        </Text>
      </S.Container>
    </S.Card>
  );
};
